import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    default: (props) => {
      const translationKey = props.i18nKey || 'mixed.default';

      return translationKey;
    },
    required: 'common:errors.requiredField',
  },
  string: {
    email: 'common:errors.email',
    max: ({ max }) => ({ key: 'common:errors.max500chars', options: { count: max } }),
  },
  array: {
    min: ({ min }) => ({ key: 'common:errors.chooseAtLeastOne', options: { count: min } }),
  },
});

Yup.addMethod(Yup.string, 'validPassword', function (message) {
  return this.test('validPassword', message, function (value) {
    if (!value) {
      return true;
    }

    const isValid = value && value.length >= 8 && /^(?=.*?[A-z])((?=.*?[0-9])|(?=.*?[#?!@$%^&*-])).{8,}$/.test(value);

    return isValid || this.createError({ params: { message, i18nKey: 'common:errors.password' } });
  });
});

Yup.addMethod(Yup.boolean, "isChecked", function (message) {
  return this.test("isChecked", message, function (value) {
    if (value === undefined || value === null) {
      return this.createError({ params: { message, i18nKey: 'common:errors.checkedField' } });
    }
    const isValid = value === true;

    return isValid || this.createError({ params: { message, i18nKey: 'common:errors.checkedField' } });
  });
});
